export default "__VITE_ASSET__CzvjZBJu__"